import { fullName } from 'utils/full-name';
export const getUserLabel = (user)=>{
    return fullName(user) || (user === null || user === void 0 ? void 0 : user.emailId);
};
